import React from 'react';
import { ReactSVG } from 'react-svg';
import styled from 'styled-components';
import { IconProps, SVGProps } from './types';

import { spacing } from '../../base';
import './styles.scss';
import { generateID } from '../../base/helper';

// Define the styled component outside of the CustomIcon component
const StyledSVG = styled(ReactSVG)<SVGProps>`
  & div {
    width: ${(props) => (props.$size ? `${props.$size}px` : spacing.space_l)};
    height: ${(props) => (props.$size ? `${props.$size}px` : spacing.space_l)};
  }

  & div svg {
    width: ${(props) => (props.$size ? `${props.$size}px` : spacing.space_l)};
    height: ${(props) => (props.$size ? `${props.$size}px` : spacing.space_l)};
  }

  ${(props) =>
    props.$color &&
    `& div svg g path,
      & div svg path {
        fill: ${props.$color};
      }
    `}
`;

const CustomIcon: React.FC<IconProps> = ({
  id = generateID('clientos-ui-toolkit-custom-icon'),
  iconPath,
  title,
  color,
  size,
  className = ''
}) => {
  return (
    <StyledSVG
      id={id}
      $color={color}
      $size={size}
      className={`uitoolkit-custom-icon ${className}`}
      onError={(error) => {
        console.error('Error injecting svg icon', error);
      }}
      title={title || ''}
      src={iconPath}
    />
  );
};

export default CustomIcon;
